export default "__VITE_ASSET__11eba699__"